import {timeParsing} from "../../../Constant";
import {timeIntervals} from "../../../Constant";
const initialState = {
    timeParse: timeParsing.sec.key,
    timeInterval: timeIntervals.last15Min.key
};
export default initialState;